<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="modalidad" titulo="Modalidad/ Coordinación escolar" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>

        <section class="section" style="padding: 1rem !important; overflow:auto; height: 87.2vh;">
          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos" (click)="ctrl.cargarCatalogo('dias_semana', 'dia-semana');"></a>
          <a id="message" (click)="ctrl.mostrar_mensaje(titulo, mensaje, clase);"></a>
          <a id="despues_de_guardar" (click)="actualizar_promedios()"></a>
          <div class="tabs is-boxed">
            <ul>
              <li [ngClass]="{ 'is-active' : tab == 1}">
                <a (click)="tab=1">
                  <span class="icon ">
                    <i class="fa fa-home"></i>
                  </span>
                  <span>General</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 2}">
                <a (click)="tab=2">
                  <span class="icon ">
                    0.0
                  </span>
                  <span>Decimales</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 3}">
                <a (click)="tab=3">
                  <span class="icon ">
                    <i class="fa fa-ban"></i>
                  </span>
                  <span>Reprobación</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 4}">
                <a (click)="tab=4">
                  <span class="icon ">
                    <i class="fa fa-shield"></i>
                  </span>
                  <span>No presento.</span>
                </a>
              </li>

            </ul>
          </div>

          <div [ngClass]="{ 'is-hidden': tab != 1}">

            <div class="columns">

              <div class="column is-6">
                <label class="label">Nombre:</label>
                <p class="control has-icons-left has-icons-right">
                  <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required')}"
                    placeholder="Nombre" formControlName="nombre">
                  <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required')">
                    <i class="fa fa-warning"></i>
                  </span>
                  <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required')">Este campo es
                    requerido.</span>
                </p>
              </div>

              <div class="column is-6">
                <label class="label">Nombre para impresiones oficiales:</label>
                <p class="control has-icons-left has-icons-right">
                  <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre_imprimir').hasError('required')}"
                    placeholder="Nombre para imprimir en PDF" formControlName="nombre_imprimir">
                  <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre_imprimir').hasError('required')">
                    <i class="fa fa-warning"></i>
                  </span>
                  <span class="help is-danger" *ngIf="ctrl.dato.get('nombre_imprimir').hasError('required')">Este campo es
                    requerido.</span>
                </p>
              </div>

              


            </div>

            <div class="columns">

              <div class="column is-4">

                            <label class="label">Tipo RVOE:</label>
                                                          <div class="control has-icons-left has-icons-right">
                                                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('tipo_rvoe').hasError('required')}">
                                                              <select class="select" name="tipo_rvoe" formControlName="tipo_rvoe">
                                                                <option value="ESTATAL"> ESTATAL </option>
                                                                <option value="FEDERAL"> FEDERAL </option>
                                                              </select>
                                                            </div>
                                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('tipo_rvoe').hasError('required')">
                                                              <i class="fa fa-warning"></i>
                                                            </span>
                                                            <span class="help is-danger" *ngIf="ctrl.dato.get('tipo_rvoe').hasError('required')">Este campo
                                                              es requerido.</span>
                                                          </div> 

              </div>

              <div class="column  is-4">
                <label class="label">Duración(meses):</label>
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('duracion_meses').hasError('required')}"
                    placeholder="Duración(meses / numérico )" formControlName="duracion_meses">
                  <span class="icon is-small is-right" *ngIf="ctrl.dato.get('duracion_meses').hasError('required')">
                    <i class="fa fa-warning"></i>
                  </span>
                  <span class="help is-danger" *ngIf="ctrl.dato.get('duracion_meses').hasError('required')">Este campo es
                    requerido.</span>
                </p>
              </div>

              <div class="column is-4">
                <label class="label">Número de parciales:</label>
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('numero_parciales').hasError('required')}"
                    placeholder="Número de parciales ( numérico )" formControlName="numero_parciales">
                  <span class="icon is-small is-right" *ngIf="ctrl.dato.get('numero_parciales').hasError('required')">
                    <i class="fa fa-warning"></i>
                  </span>
                  <span class="help is-danger" *ngIf="ctrl.dato.get('numero_parciales').hasError('required')">Este campo
                    es requerido.</span>
                </p>
              </div>

              

              
            </div>

            <div class="columns">
              <div class="column is-12">
                <nav class="panel">
                  <section class="hero is-light">
                    <div class="hero-head">
                      <nav class="level">
                        <!-- Left side -->
                        <div class="level-left">
                          <div class="level-item">
                            <p class="title is-3" style=" padding-left: 10px; ">
                              <span class="icon is-medium">
                                <i class="icon-list "></i>
                              </span> Lista de días de la semana que contempla la Modalidad
                            </p>
                          </div>


                        </div>

                        <!-- Right side -->
                        <div class="level-right" style="margin-right: 5px;">

                          <a class="navbar-item  tooltip" (click)="ctrl.agregar_form_array(ctrl.dato.controls.modalidades_dias, form_modalidades_dias)">
                            <span class="icon has-text-success">
                              <i class="icon-add2"></i>
                            </span>
                            <span class="tooltiptext">Agregar</span>
                          </a>
                        </div>
                      </nav>
                    </div>
                  </section>
                  <div class="panel-block">
                    <div formArrayName="modalidades_dias">
                      <div *ngFor="let item of ctrl.dato.controls.modalidades_dias.controls; let i=index" class="column" style="min-width:280px; width:19.5%; float:left">
                        <nav class="panel" [formGroupName]="i">
                          <div class="panel-heading">
                            <label class="label is-10">Día {{i+1}} </label>

                            <a style="float:right; margin-top: -25px;" class="is-danger is-2" (click)="ctrl.quitar_form_array(ctrl.dato.controls.modalidades_dias, i)">
                              <span class="icon has-text-danger">
                                <i class="icon-trash"></i>
                              </span>
                            </a>
                          </div>
                          <label class="panel-block">
                            <div class="select">
                              <select class="select" name="dias_semanas_id" formControlName="dias_semanas_id" (change)="descartar($event, ctrl.dias_semana, i)">
                                <option *ngFor="let val of ctrl.dias_semana" value="{{val.id}}">{{ val.nombre }}</option>
                              </select>
                            </div>
                          </label>
                        </nav>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </div>

          </div>
          <div [ngClass]="{ 'is-hidden': tab != 2}">
            <div class="column is-12">
              <label class="label">En caso de reprobar:</label>
              <div class="control has-icons-left has-icons-right">
                <div class="b-checkbox is-info">
                  <input id="ignorar_redondeo_reprobado" class="styled" [checked]="ctrl.dato.get('ignorar_redondeo_reprobado').value == '1' ? true : false"
                    formControlName="ignorar_redondeo_reprobado" type="checkbox">
                  <label for="ignorar_redondeo_reprobado" style="color:red">
                    No redondear
                  </label>
                </div>
              </div>
            </div>
            <fieldset>
              <legend>Decimales aplicados</legend>
              <div class="columns">
                <div class="column is-3">
                  <label class="label">Promedio del parcial:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('parcial_numero_decimales').hasError('required')}"
                      placeholder="Decimales aplicados alparcial ( numérico )" formControlName="parcial_numero_decimales">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('parcial_numero_decimales').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('parcial_numero_decimales').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la materia: {{ctrl.dato.get('materia_numero_decimales').value}}</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('materia_numero_decimales').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la materia ( numérico )" formControlName="materia_numero_decimales">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('materia_numero_decimales').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('materia_numero_decimales').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio del nivel:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('periodo_numero_decimales').hasError('required')}"
                      placeholder="Decimales aplicados al promedio del nivel ( numérico )" formControlName="periodo_numero_decimales">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodo_numero_decimales').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('periodo_numero_decimales').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la carrera:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('general_numero_decimales').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la carrera ( numérico )" formControlName="general_numero_decimales">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('general_numero_decimales').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('general_numero_decimales').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>
              </div>

            </fieldset>

            <fieldset>
              <legend>Tipo de redondeo aplicado</legend>

              <div class="columns">
                <div class="column is-3">
                  <label class="label"> Promedio del parcial:</label>
                  <div class="control has-icons-left has-icons-right">
                    <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('parcial_tipo_redondeo').hasError('required')}">
                      <select class="select" name="parcial_tipo_redondeo" formControlName="parcial_tipo_redondeo">
                        <option value="NINGUNA" selected> NINGUNA </option>
                        <option value="PHP_ROUND_HALF_UP"> HACIA ARRIBA </option>
                        <option value="PHP_ROUND_HALF_DOWN"> HACIA ABAJO </option>
                      </select>
                    </div>
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('parcial_tipo_redondeo').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('parcial_tipo_redondeo').hasError('required')">Este
                      campo es requerido.</span>
                  </div>
                </div>

                <div class="column is-3">
                  <label class="label"> Promedio de la materia:</label>
                  <div class="control has-icons-left has-icons-right">
                    <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('materia_tipo_redondeo').hasError('required')}">
                      <select class="select" name="materia_tipo_redondeo" formControlName="materia_tipo_redondeo">
                        <option value="NINGUNA" selected> NINGUNA </option>
                        <option value="PHP_ROUND_HALF_UP"> HACIA ARRIBA </option>
                        <option value="PHP_ROUND_HALF_DOWN"> HACIA ABAJO </option>
                      </select>
                    </div>
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('materia_tipo_redondeo').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('materia_tipo_redondeo').hasError('required')">Este
                      campo es requerido.</span>
                  </div>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio del nivel:</label>
                  <div class="control has-icons-left has-icons-right">
                    <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('periodo_tipo_redondeo').hasError('required')}">
                      <select class="select" name="periodo_tipo_redondeo" formControlName="periodo_tipo_redondeo">
                        <option value="NINGUNA" selected> NINGUNA </option>
                        <option value="PHP_ROUND_HALF_UP"> HACIA ARRIBA </option>
                        <option value="PHP_ROUND_HALF_DOWN"> HACIA ABAJO </option>
                      </select>
                    </div>
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodo_tipo_redondeo').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('periodo_tipo_redondeo').hasError('required')">Este
                      campo es requerido.</span>
                  </div>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la carrera:</label>
                  <div class="control has-icons-left has-icons-right">
                    <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('general_tipo_redondeo').hasError('required')}">
                      <select class="select" name="general_tipo_redondeo" formControlName="general_tipo_redondeo">
                        <option value="NINGUNA" selected> NINGUNA </option>
                        <option value="PHP_ROUND_HALF_UP"> HACIA ARRIBA </option>
                        <option value="PHP_ROUND_HALF_DOWN"> HACIA ABAJO </option>
                      </select>
                    </div>
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('general_tipo_redondeo').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('general_tipo_redondeo').hasError('required')">Este
                      campo es requerido.</span>
                  </div>
                </div>
              </div>

            </fieldset>
          </div>
          <div [ngClass]="{ 'is-hidden': tab != 3}">
            <fieldset>
              <legend>Leyenda para imprimir, en caso de reprobar</legend>
              <div class="columns">
                <div class="column is-3">
                  <label class="label">Promedio del parcial:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('parcial_leyenda_para_imprimir').hasError('required')}"
                      placeholder="Decimales aplicados alparcial ( numérico )" formControlName="parcial_leyenda_para_imprimir">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('parcial_leyenda_para_imprimir').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('parcial_leyenda_para_imprimir').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la materia:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('materia_leyenda_para_imprimir').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la materia ( numérico )" formControlName="materia_leyenda_para_imprimir">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('materia_leyenda_para_imprimir').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('materia_leyenda_para_imprimir').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio del nivel:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('periodo_leyenda_para_imprimir').hasError('required')}"
                      placeholder="Decimales aplicados al promedio del nivel ( numérico )" formControlName="periodo_leyenda_para_imprimir">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodo_leyenda_para_imprimir').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('periodo_leyenda_para_imprimir').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la carrera:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('general_leyenda_para_imprimir').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la carrera ( numérico )" formControlName="general_leyenda_para_imprimir">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('general_leyenda_para_imprimir').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('general_leyenda_para_imprimir').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>
              </div>

            </fieldset>

            <fieldset>
              <legend>Valor para promediar, en caso de reprobar</legend>
              <div class="columns">
                <div class="column is-3">
                  <label class="label">Promedio del parcial:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('parcial_valor_para_promediar').hasError('required')}"
                      placeholder="Decimales aplicados alparcial ( numérico )" formControlName="parcial_valor_para_promediar">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('parcial_valor_para_promediar').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('parcial_valor_para_promediar').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la materia:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('materia_valor_para_promediar').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la materia ( numérico )" formControlName="materia_valor_para_promediar">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('materia_valor_para_promediar').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('materia_valor_para_promediar').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio del nivel:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('periodo_valor_para_promediar').hasError('required')}"
                      placeholder="Decimales aplicados al promedio del nivel ( numérico )" formControlName="periodo_valor_para_promediar">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodo_valor_para_promediar').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('periodo_valor_para_promediar').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la carrera:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('general_valor_para_promediar').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la carrera ( numérico )" formControlName="general_valor_para_promediar">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('general_valor_para_promediar').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('general_valor_para_promediar').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>
              </div>

            </fieldset>
          </div>
          <div [ngClass]="{ 'is-hidden': tab != 4}">
            <fieldset>
              <legend>Leyenda para imprimir, en caso de no presento</legend>
              <div class="columns">
                <div class="column is-3">
                  <label class="label">Promedio del parcial:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('parcial_leyenda_para_imprimir_np').hasError('required')}"
                      placeholder="Decimales aplicados alparcial ( numérico )" formControlName="parcial_leyenda_para_imprimir_np">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('parcial_leyenda_para_imprimir_np').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('parcial_leyenda_para_imprimir_np').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la materia:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('materia_leyenda_para_imprimir_np').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la materia ( numérico )" formControlName="materia_leyenda_para_imprimir_np">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('materia_leyenda_para_imprimir_np').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('materia_leyenda_para_imprimir_np').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio del nivel:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('periodo_leyenda_para_imprimir_np').hasError('required')}"
                      placeholder="Decimales aplicados al promedio del nivel ( numérico )" formControlName="periodo_leyenda_para_imprimir_np">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodo_leyenda_para_imprimir_np').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('periodo_leyenda_para_imprimir_np').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la carrera:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('general_leyenda_para_imprimir_np').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la carrera ( numérico )" formControlName="general_leyenda_para_imprimir_np">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('general_leyenda_para_imprimir_np').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('general_leyenda_para_imprimir_np').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>
              </div>

            </fieldset>

            <fieldset>
              <legend>Valor para promediar, en caso de reprobar</legend>
              <div class="columns">
                <div class="column is-3">
                  <label class="label">Promedio del parcial:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('parcial_valor_para_promediar_np').hasError('required')}"
                      placeholder="Decimales aplicados alparcial ( numérico )" formControlName="parcial_valor_para_promediar_np">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('parcial_valor_para_promediar_np').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('parcial_valor_para_promediar_np').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la materia:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('materia_valor_para_promediar_np').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la materia ( numérico )" formControlName="materia_valor_para_promediar_np">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('materia_valor_para_promediar_np').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('materia_valor_para_promediar_np').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio del nivel:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('periodo_valor_para_promediar_np').hasError('required')}"
                      placeholder="Decimales aplicados al promedio del nivel ( numérico )" formControlName="periodo_valor_para_promediar_np">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodo_valor_para_promediar_np').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('periodo_valor_para_promediar_np').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>

                <div class="column is-3">
                  <label class="label">Promedio de la carrera:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('general_valor_para_promediar_np').hasError('required')}"
                      placeholder="Decimales aplicados al promedio de la carrera ( numérico )" formControlName="general_valor_para_promediar_np">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('general_valor_para_promediar_np').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('general_valor_para_promediar_np').hasError('required')">Este
                      campo es requerido.</span>
                  </p>
                </div>
              </div>

            </fieldset>
          </div>

        </section>
      </form>
    </div>
  </div>
</div>
